import { FUNDGENIUS_HQ_ROUTE_SEGMENT } from './constants';

export function buildAgencyFundGeniusBasePath(agencyId) {
  return `/agency/${agencyId}/${FUNDGENIUS_HQ_ROUTE_SEGMENT}`;
}

export function buildAgencyFundGeniusPath(agencyId, segment = '') {
  const base = buildAgencyFundGeniusBasePath(agencyId);
  if (!segment) return base;
  return `${base}/${segment.replace(/^\//, '')}`;
}

export function buildPlatformFundGeniusBasePath() {
  return `/platform/${FUNDGENIUS_HQ_ROUTE_SEGMENT}`;
}

export function buildPlatformFundGeniusPath(segment = '') {
  const base = buildPlatformFundGeniusBasePath();
  if (!segment) return base;
  return `${base}/${segment.replace(/^\//, '')}`;
}

export function buildStandaloneFundGeniusPath(segment = '') {
  const base = `/${FUNDGENIUS_HQ_ROUTE_SEGMENT}`;
  if (!segment) return base;
  return `${base}/${segment.replace(/^\//, '')}`;
}
